import axios from "axios";  // ✅ IMPORT NECESSARY

// ✅ Sirf .env se URL lega
const API_BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL = `${API_BASE_URL}Rating`;

// ✅ Image URL bhi same domain se lega
const IMAGE_BASE_URL = API_BASE_URL?.replace('/api/', '/BannerImage/');

export const getAllBanners = async (categoryId) => {
  try {
    const response = await axios.get(`${BASE_URL}/GetAllBanner`);
    const banners = Array.isArray(response.data) ? response.data : [];

    console.log("📦 ALL BANNERS FROM SERVER:", banners);
    console.log("🎯 REQUESTED CATEGORY ID:", categoryId);

    // 1. Filter by specific category if provided (strict matching like app)
    let filtered = [];
    if (categoryId) {
      filtered = banners.filter(
        (item) => Number(item.bannerCategoryId) === Number(categoryId) && item.isActive !== false
      );
    } else {
      filtered = banners.filter((item) => item.isActive !== false);
    }

    const mappedBanners = filtered.map((item) => ({
      ...item,
      image: item.image,
      imageUrl: item.image ? `${IMAGE_BASE_URL}${item.image}` : null,
    }));

    console.log("✅ RETURNED BANNERS:", mappedBanners);
    return mappedBanners;
  } catch (error) {
    console.error("Banner API Error:", error);
    return [];
  }
};